module.exports = __webpack_public_path__ + "img/point4_rollingTxt.df18660c.png";